import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { clearPrerenderedHead } from "@/hooks/useDocumentHead";

/**
 * Drops the prerendered head once the visitor navigates inside the app.
 *
 * Each URL is served with its own head baked in (scripts/prerender-head.tsx).
 * On the page that was loaded those tags are correct and, for pages that do not
 * manage their own head, they are the only ones — so they stay. After a
 * client-side navigation they describe the previous page, so they are removed.
 */
export default function PrerenderedHeadScope() {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    clearPrerenderedHead();
  }, [pathname]);

  return null;
}
